import { Button, Typography } from '@material-ui/core';
import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OrderContext } from '../OrderContext';
import Summary from '../OrderSummary/Summary';
import NobelLogo from '../images/nobel_logo.png'
import { getStorageValue } from '.';

const useMediaQuery = (query: string) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = () => setMatches(media.matches);
        window.addEventListener("resize", listener);
        return () => window.removeEventListener("resize", listener);
    }, [matches, query]);

    return matches;
}

const PrintContent: React.FC<PrintButtonProps> = ({ returnOrderNumber, exchangeOrderNumber }) => {
    const isPrint = useMediaQuery('print')
    const { pickup, shipTo, addresses, orderType, warehouseAddress } = useContext(OrderContext)
    const { t } = useTranslation()

    const p = addresses.find(a => a.customer === pickup) // || { name1: 'Ben Leach', street: '6692 Russell Heights Dr.', postalCode: '45248', city: 'Cincinnati', region: 'OH', country: 'US' }
    const s = addresses.find(a => a.customer === shipTo) // || { name1: 'Ben Leach', street: '6692 Russell Heights Dr.', postalCode: '45248', city: 'Cincinnati', region: 'OH', country: 'US' }

    return (
        <div id='print' style={{ display: isPrint ? undefined : 'none' }}>
            <div style={{ display: 'flex', gap: 30, marginBottom: 30 }}>
                <div style={{ display: 'flex', width: '100%' }}>
                    <div style={{ width: '45%' }}>
                        <img src={NobelLogo} alt="" style={{ width: '100%' }} />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '65%', gap: 30, fontSize: '.875rem' }}>
                        <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                            {returnOrderNumber && <Typography variant='body1'>{returnOrderNumber}</Typography>}
                            {exchangeOrderNumber && <Typography variant='body1'>{exchangeOrderNumber}</Typography>}
                        </div>
                        <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                            {returnOrderNumber && <Typography variant='body1'>{t('return_order_number')}:</Typography>}
                            {exchangeOrderNumber && <Typography variant='body1'>{t('exchange_order_number')}:</Typography>}
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ display: 'flex', marginBottom: 15 }}>
                {p && <div style={{ flex: 1 }}>
                    <Typography variant='h5' style={{ marginBottom: 15 }}>{t('pickup_address')}:</Typography>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{p.name1}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{p.street}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{p.postalCode}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{p.city}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{p.region}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{p.country}</p>
                </div>}

                {pickup === 'NoPickup' && orderType === 'Return' && warehouseAddress && <div style={{flex: 1}}>
                    <Typography variant='h5' style={{marginBottom: 15}}>{t('shipping_address')}:</Typography>
                    {warehouseAddress.split('\n').map(x => <p style={{marginTop: 0, marginBottom: 0}}>{x}</p>)}
                </div>}

                {s && orderType === 'Exchange' && <div style={{ flex: 1 }}>
                    <Typography variant='h5' style={{ marginBottom: 15 }}>{t('shipping_address')}:</Typography>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{s.name1}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{s.street}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{s.postalCode}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{s.city}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{s.region}</p>
                    <p style={{ marginTop: 0, marginBottom: 0 }}>{s.country}</p>
                </div>}
            </div>
            <Summary disableSmall simulateOverride={getStorageValue('simulate')} />
        </div>
    )
}

type PrintButtonProps = { returnOrderNumber?: string, exchangeOrderNumber?: string }

const PrintButton: React.FC<PrintButtonProps> = ({ returnOrderNumber, exchangeOrderNumber }) => {
    const { t } = useTranslation()

    const handlePrint = () => {
        const contents = document.getElementById('print')?.innerHTML
        const styles = Array.from(document.getElementsByTagName('STYLE')).map(s => s.outerHTML).reduce((acc, val) => acc + val)

        const doc = window.open('', '', 'height=1100, width=900')
        doc?.document.write('<html>')
        doc?.document.write(`<head><meta name="viewport" content="width=800, initial-scale=0.7"><title>Nobel Return Order</title>${styles}<style>@media print { body { font-size: 0.6rem; } }</style></head>`)
        doc?.document.write(`<body>${contents}</body>`)
        doc?.document.write('</html>')
        doc?.print()

        doc?.close()
    }

    return <>
        <Button onClick={handlePrint} color='primary' variant='contained'>{t('print_order_summary')}</Button>
        <PrintContent returnOrderNumber={returnOrderNumber} exchangeOrderNumber={exchangeOrderNumber} />
    </>
}

export default PrintButton
